import { useQuery } from '@tanstack/react-query';
import Image from 'next/image';
import { ReactNode, useMemo } from 'react';

import {
	getAssetsPlayersImages,
	type GetSimpleFooterResponse,
} from 'services/idm';

import { PUBLIC_CHANNEL } from 'tools/environments';

import { CMSPicture } from 'core/generic/elements/cms-picture';

import { PageTemplate } from '../patterns';
import styles from './layout.module.scss';

type LayoutProps = {
	children: ReactNode;
	footerData: GetSimpleFooterResponse;
	backgroundUrl?: string;
	locale?: string;
};

export const Layout = ({
	children,
	footerData,
	backgroundUrl = '',
	locale = 'en',
}: LayoutProps) => {
	const theme = PUBLIC_CHANNEL || 'mancity';

	const { data: playerImages } = useQuery({
		queryKey: ['login-player-images', locale],
		queryFn: () => getAssetsPlayersImages(locale),
	});

	const playerImage = useMemo(
		() => playerImages?.[Math.floor(Math.random() * playerImages.length)],
		[playerImages]
	);
	const backgroundImage = useMemo(
		() => backgroundUrl || `/images/${theme}/signin-background.webp`,
		[backgroundUrl, theme]
	);

	return (
		<PageTemplate footerData={footerData}>
			<div className={styles.backgroundWrapper}>
				<div className={styles.imageContainer}>
					{backgroundImage && (
						<>
							<Image
								src={backgroundImage}
								alt="background"
								className={styles.background}
								fill
								priority
							/>

							{playerImages && (
								<CMSPicture
									url={playerImage?.url || ''}
									alt={playerImage?.alt || ''}
									className={styles.player}
									height={359}
									addBackgroundColour={false}
								/>
							)}
						</>
					)}
				</div>

				<div className="container">
					<div className={`row`}>
						<div className="col-12">
							<div className={`${styles.container}`}>
								<div className={styles.formWrapper}>
									{children}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</PageTemplate>
	);
};
